import { object } from "yup"
import { UserModel } from "../app/modules/auth/models/UserModel"
import { ChatAgent, ChatGroupMessage, ChatGroupRoom, ChatMessage, ChatRoom, ListChatAgent, ListChatGroupRoom, ListChatRoom } from "../interfaces/Chat/Chat"
import { ListChatPhone } from "../interfaces/Chat/ListChatPhone"
import { RecentChatHistory } from "../interfaces/Chat/RecentChatHistory"
import { Settings } from "../interfaces/Settings"
import { CustomeStoreCompanyIdProps } from "../stores/CustomeStore"
import moment from "moment-timezone";
import { IntlShape } from "react-intl"

const focusChatInput = async () => {
    await new Promise(resolve => setTimeout(resolve, 0))
    const chatInput = document.getElementById('chat-input') as HTMLTextAreaElement
    chatInput?.focus()
}

export { focusChatInput }

export const checkedIsUserHappyPlay = (user: UserModel, companyId: CustomeStoreCompanyIdProps) => {
    if ((user.data.company_id === companyId.happyPlay) && user.data.is_superadmin) {
        return true
    }
    return false
}

export const getInitialsOrPhonePrefix = (recentChatHistory: { chat_name: string; chat_phone: string }): string => {
    if (recentChatHistory.chat_name) {
        const words = recentChatHistory.chat_name.split(' ');
        const initials = words.length > 1
            ? words.map((word: string) => word[0]).join('')
            : words[0][0];

        return recentChatHistory.chat_name !== recentChatHistory.chat_phone
            ? initials.substring(0, 2).toUpperCase()
            : recentChatHistory.chat_phone.substring(0, 2).toUpperCase();
    }
    return recentChatHistory.chat_phone.substring(0, 2).toUpperCase();
};

export const sortListChat = (data: RecentChatHistory[]) => {
    const sortedHistories = [...data].sort(
        (a, b) => new Date(b.chat_date).getTime() - new Date(a.chat_date).getTime()
    );

    return sortedHistories
}

export const generateColorChatPhone = (index: number) => {
    const colors = ["#FF5733", "#009ef7", "#ffa500", "#109010", "#FF33A1", "#A133FF", "#1d633c", "#e48a17", "#caae50", "#b22222"];

    return colors[index % colors.length];
}

export const stringToColor = (str: string): string => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    let color = "#";
    for (let i = 0; i < 3; i++) {
        const value = (hash >> (i * 8)) & 0xff;
        color += ("00" + value.toString(16)).slice(-2);
    }
    return color;
}

export const calculateTotalChats = (data: Record<string, { totalChats: number; totalRecentChats: number }>) => {
    return Object.values(data).reduce(
        (acc, curr) => {
            acc.totalChats += curr.totalChats;
            acc.totalRecentChats += curr.totalRecentChats;
            return acc;
        },
        { totalChats: 0, totalRecentChats: 0 }
    );
};

export const isViewOnlyChat = (settings: Settings, user: UserModel, selectedChatPhone: ListChatPhone[], chatAgent: ChatAgent[]) => {
    if (selectedChatPhone.length > 1) return true
    else if (selectedChatPhone.some(item => item.scope === "chat_view")) return true
    else if (settings.chat_version === 'v2') {
        if (chatAgent && (chatAgent[chatAgent.length - 1].state === "active" || chatAgent[chatAgent.length - 1].state === "waiting") && chatAgent[chatAgent.length - 1].handler.id !== user.data.id) return true
        // if (selectedChatPhone.length > 0 && !selectedChatPhone[0]?.isAgent) return true
    } else return false
}

export const isActiveSession = (chatAgent: ChatAgent[], user: UserModel, settings: Settings) => {
    if (settings.chat_version !== 'v2') return true
    else {
        if (!chatAgent) return false

        if ((chatAgent[chatAgent.length - 1].state === "active" || chatAgent[chatAgent.length - 1].state === "waiting") && chatAgent[chatAgent.length - 1].handler.id === user.data.id) return true
        else return false
    }
}

export const isShowBtnEndSession = (chatAgent: ChatAgent[], user: UserModel) => {
    if (!chatAgent) return false

    if (chatAgent[chatAgent.length - 1].state === "waiting" && chatAgent[chatAgent.length - 1].handler.id === user.data.id) return true
    else return false
}

export const isShowBtnCreateSession = (settings: Settings, chatRoom: ChatRoom | ChatGroupRoom, chatAgent: ChatAgent[]) => {
    if (settings.chat_version === 'v2') {
        if (chatAgent && (chatAgent[chatAgent.length - 1].state === 'active' || chatAgent[chatAgent.length - 1].state === 'waiting')) return true

        if (settings.allowAgentPreemptiveStartSessions) return true
        else if (!settings.allowAgentPreemptiveStartSessions && !chatRoom.chat.fromMe) return true
        else return false
    } return true
}

export const isShowChatRoom = (settings: Settings, listChatAgents: ListChatAgent, dataChatRoom: ChatRoom, user: UserModel) => {
    if(settings.chat_superadmin_merchant_only && !dataChatRoom.isMerchantOnly && user.data.is_superadmin) return false
    else if(settings.chat_show_pic_only && !dataChatRoom.isMerchantOnly && !user.data.is_superadmin) return false
    else if (settings.chat_version === 'v2' && !user.data.is_superadmin) {
        const dataSession = listChatAgents[`${dataChatRoom.roomPhone}-${dataChatRoom.as}`]
        if (dataSession && dataSession.length > 0) {
            if ((dataSession[dataSession.length - 1].state === 'active' || dataSession[dataSession.length - 1].state === 'waiting') && dataSession[dataSession.length - 1].handler.id === user.data.id) return true
            else if ((dataSession[dataSession.length - 1].state === 'active' || dataSession[dataSession.length - 1].state === 'waiting') && dataSession[dataSession.length - 1].handler.id !== user.data.id) return false
            else return true
        } else return true
    } else return true
}

export const sortChatRooms = (data: ListChatRoom | ListChatGroupRoom) => {
    const entries = Object.entries(data);

    // 2. Sorting berdasarkan receivedAt
    entries.sort(([, a], [, b]) => new Date(b.chat?.receivedAt).getTime() - new Date(a.chat?.receivedAt).getTime());

    // 3. Konversi kembali ke object jika diperlukan
    const sortedData = Object.fromEntries(entries);

    return sortedData
}

export const isPhoneNumber = (text: string): string => {
    // Regex untuk mendeteksi nomor telepon dalam format internasional (+62xxxx) dan lokal (08xxxx)
    const phoneRegex = /^(\+?[1-9][0-9]{6,14}|08[0-9]{8,11})$/;

    // Pecah teks menjadi kata-kata berdasarkan spasi
    const words = text.split(/\s+/);

    // Cari kata yang cocok dengan pola nomor telepon
    const phoneNumber = words.find(word => phoneRegex.test(word));

    // Kembalikan nomor telepon atau string kosong jika tidak ditemukan
    return phoneNumber || "";
};

export const isMerchantOnly = (settings: Settings, chat: any, user: UserModel) => {
    if (settings.chat_superadmin_merchant_only && chat.isMerchantOnly && user.data.is_superadmin) return true
    else if (settings.chat_show_pic_only && chat.isMerchantOnly && !user.data.is_superadmin) return true
    else return false
}

export const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

export const countUnreadMessages = (chat: ChatMessage[]): number => {
    // Temukan index pesan terakhir dari saya (fromMe: true)
    const lastSentIndex = chat.findIndex((msg) => msg.fromMe === true);

    // Jika tidak ada pesan dari saya, semua pesan masuk dianggap belum dibaca
    if (lastSentIndex === -1) {
        return chat.filter((msg) => !msg.fromMe).length;
    }

    // Ambil semua pesan setelah pesan terakhir dari saya, yang bukan dari saya
    const unreadMessages = chat.slice(0, lastSentIndex).filter((msg) => !msg.fromMe);

    return unreadMessages.length;
}

export const hasSentMessages = (chat: ChatMessage[]): boolean => {
    return chat.some((msg) => msg.fromMe === true);
}

export const chatMode = (version: string): string => {
    if (version === 'v2') return 'chat-agent'
    else return 'omnichannel'
}

export const displayDate = (message: ChatMessage | ChatGroupMessage, intl: IntlShape) => {
    const now = moment();
    const msgTime = moment(message.receivedAt, "YYYY-MM-DD HH:mm:ss");
    const diff = now.startOf("day").diff(msgTime.startOf("day"), "days");

    if (diff === 0) return intl.formatMessage({ id: "PREDEFINED_RANGES.TODAY" });
    if (diff === 1) return intl.formatMessage({ id: "PREDEFINED_RANGES.YESTERDAY" });
    if (now.isoWeek() === msgTime.isoWeek() && diff < 7)
        return msgTime.format("dddd").toUpperCase();

    return msgTime.format("DD MMMM YYYY").toUpperCase();
};

export const replaceMentionsWithPhone = (text: string): string => {
    // cari pola @[Display](ID/Phone)
    return text.replace(/@\[[^\]]+\]\(([^)]+)\)/g, "@$1 ");
}

export const returnListMentions = (text: string): string[] => {
    const regex = /@\[[^\]]+\]\(([^)]+)\)/g;
    const phones: string[] = [];
    let match;

    while ((match = regex.exec(text)) !== null) {
        phones.push(match[1] + '@s.whatsapp.net'); // ambil phone
    }

    return phones;
}